var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdsIconArchLower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "normal",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-fill",
    d: "m32,38.12c-12.41,0-22.5-12.46-22.5-27.76h8c0,10.9,6.5,19.76,14.5,19.76s14.5-8.87,14.5-19.76h8c0,15.31-10.09,27.76-22.5,27.76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-fill",
    d: "m32.13,55.64c-.47,0-.95-.17-1.33-.5l-10.95-9.72c-.83-.73-.9-2-.17-2.82.73-.83,2-.9,2.82-.17l9.62,8.54,9.62-8.54c.83-.73,2.09-.66,2.82.17.73.83.66,2.09-.17,2.82l-10.95,9.72c-.38.34-.85.5-1.33.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsIconArchLower);
export default __webpack_public_path__ + "static/media/SDS_icon_Arch_Lower.144fbd0ad63cfcfd3f68bc7d24dffccf.svg";
export { ForwardRef as ReactComponent };